import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'WIZARD' });



// WEBPACK FOOTER //
// ./src/frontend/init-wizard/handlers.js